import React, { useState } from 'react'
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import StarBorderIcon from '@material-ui/icons/StarBorder';

const StarRating = ({
  color, size, type, index, setRating, onRatingChange, disabled,
}) => {
  const handleClick = (e, i) => {
    const currentTargetRect = e.currentTarget.getBoundingClientRect();
    const offsetX = e.pageX - currentTargetRect.left;
    const { width } = currentTargetRect;
    const clickedOnLeftHalf = width / 2 > offsetX

    if (clickedOnLeftHalf) {
      onRatingChange(i - 0.5)
      setRating(i - 0.5)
    } else {
      onRatingChange(i)
      setRating(i)
    }
  }
  let SelectedIcon = null;
  switch (type) {
    case 'full':
      SelectedIcon = StarIcon;
      break;
    case 'half':
      SelectedIcon = StarHalfIcon;
      break;
    case 'empty':
      SelectedIcon = StarBorderIcon;
      break;
    default:
      SelectedIcon = null;
      break
  }
  return (
    <SelectedIcon
      color={disabled ? 'disabled' : color}
      disabled
      fontSize={size}
      onClick={(e) => (!disabled ? handleClick(e, index) : () => {})}
    />
  )
}

const CommonRating = ({
  defaultRating, maxRating, activeColor, onRatingChange, disabled, size,
}) => {
  const [rating, setRating] = useState(defaultRating);

  const emptyArray = [];
  for (let index = 0; index < maxRating; index += 1) {
    emptyArray.push(index)
  }

  return (
    <div>
      {emptyArray.map((item, i) => {
        let type = 'full';
        if (rating <= i) { type = 'empty' }
        if ((rating - i) === 0.5) { type = 'half' }
        return (
          <StarRating
            setRating={setRating}
            size={size}
            color={activeColor}
            type={type}
            disabled={disabled}
            onRatingChange={onRatingChange}
            index={i + 1}
          />
        )
      })}
    </div>
  )
}

CommonRating.defaultProps = {
  disabled: false,
  size: 'medium',
  activeColor: 'primary',
  defaultRating: 0,
  maxRating: 5,
};

export default CommonRating;
